import { Link } from "react-router-dom";
import { scrollToId } from "@/App";

export const Footer = () => (
  <footer className="bg-charcoal text-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-28">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <div className="flex items-center gap-3">
            <span className="inline-block h-2.5 w-2.5 rotate-45 bg-gold" aria-hidden="true" />
            <span className="font-serif text-4xl font-light tracking-tighter sm:text-5xl">Joseph Guild</span>
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-ivory/55">
            A network of righteous and purpose-driven businesses within the Church — connecting,
            supporting, and growing together.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Navigate</p>
          <div className="flex flex-col gap-4">
            {[
              { label: "Manifesto", id: "manifesto" },
              { label: "Register", id: "register" },
              { label: "Directory", id: "directory" },
            ].map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                className="w-fit font-mono text-xs uppercase tracking-[0.2em] text-ivory/60 transition-colors hover:text-gold"
                data-testid={`footer-${l.id}-link`}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Guild Office</p>
          <Link
            to="/admin/login"
            className="font-mono text-xs uppercase tracking-[0.2em] text-ivory/60 transition-colors hover:text-gold"
            data-testid="footer-admin-link"
          >
            Administrator login
          </Link>
        </div>
      </div>
      <div className="mt-20 flex flex-col gap-4 border-t border-ivory/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-ivory/35">
          © 2026 The Joseph Guild
        </p>
        <p className="font-serif text-sm font-light italic text-ivory/45">
          “The Lord was with Joseph, and he prospered.”
        </p>
      </div>
    </div>
  </footer>
);
